"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnvFeature = void 0;
class EnvFeature {
    outsideProduction;
    inProduction;
    constructor({ outsideProduction, inProduction }) {
        this.outsideProduction = new Set(outsideProduction);
        this.inProduction = new Set(inProduction);
        const untestable = [...this.inProduction].filter(businessUnit => !this.outsideProduction.has(businessUnit));
        if (untestable.length > 0) {
            throw new Error(`EnvFeature: in production but not outside production for ${untestable.join(', ')}`);
        }
    }
    isEnabled({ businessUnit, isProduction }) {
        return (isProduction ? this.inProduction : this.outsideProduction).has(businessUnit);
    }
}
exports.EnvFeature = EnvFeature;
